import { jsxs, jsx } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { dataAttribute } from "@contember/utilities";
import { memo, useState, useRef, useEffect } from "react";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
import { toEnumStateClass } from "../../utils/toEnumStateClass.js";
const toolbarVisibilityTreshold = 56 + 2 * 16;
const EditorCanvas = memo(({
  children,
  focusRing = true,
  inset,
  size,
  distinction,
  underlyingComponent: Component,
  componentProps: props
}) => {
  const className = props.className;
  const componentClassName = useClassNameFactory("editorCanvas");
  const [isInView, setIsInView] = useState(false);
  const intersectionRef = useRef(null);
  const observer = useRef(new IntersectionObserver((entries) => {
    entries.forEach(({ isIntersecting }) => {
      setIsInView(isIntersecting);
    });
  }, {
    rootMargin: `-${toolbarVisibilityTreshold}px 0px -${toolbarVisibilityTreshold}px 0px`
  }));
  useEffect(() => {
    const intersectionObserver = observer.current;
    if (intersectionRef.current) {
      intersectionObserver.observe(intersectionRef.current);
    }
    return () => {
      intersectionObserver.disconnect();
    };
  }, []);
  return /* @__PURE__ */ jsxs("div", { "data-focus-ring": dataAttribute(focusRing), ref: intersectionRef, className: componentClassName(null, [
    toEnumViewClass(size),
    toEnumViewClass(inset),
    toEnumViewClass(distinction),
    toEnumStateClass(isInView ? "in-view" : "not-in-view")
  ]), children: [
    /* @__PURE__ */ jsx(Component, { ...props, className: componentClassName("canvas", className) }),
    children
  ] });
});
EditorCanvas.displayName = "EditorCanvas";
export {
  EditorCanvas
};
//# sourceMappingURL=EditorCanvas.js.map
